export const translations = {
  sv: {
    nav: {
      home: "Hem",
      team: "Personal",
      gallery: "Galleri",
      quote: "Offert",
      admin: "Admin",
    },
    common: {
      cta_quote: "Begär offert",
      learn_more: "Läs mer",
      back_home: "Tillbaka till hem",
      loading: "Laddar...",
      submit: "Skicka förfrågan",
      submitting: "Skickar...",
      optional: "valfritt",
      required: "krävs",
    },
    hero: {
      eyebrow: "Åkeri & Logistik · SEDAN 2006",
      title_l1: "Bränninger",
      title_l2: "Åkeri & Logistik",
      lead:
        "Robust transport, lots och expresskörningar – över hela landet. Vi rullar dygnet runt med pålitlig personal och en stark vagnpark.",
      cta_primary: "Begär offert",
      cta_secondary: "Möt teamet",
      stats: [
        { value: "20+", label: "Års erfarenhet" },
        { value: "24/7", label: "Beredskap" },
        { value: "100%", label: "Pålitliga leveranser" },
      ],
    },
    services: {
      title: "Tjänster",
      subtitle: "Det här kör vi",
      items: [
        {
          key: "offert",
          title: "Offerter",
          desc: "Få ett tydligt och rättvist pris på transport- och logistikuppdrag.",
        },
        {
          key: "express",
          title: "Expresskörning",
          desc: "När det är bråttom. Snabb och säker leverans direkt till mottagaren.",
        },
        {
          key: "lots",
          title: "Lots",
          desc: "Eskort och lots för specialtransporter och brett gods.",
        },
        {
          key: "extra",
          title: "Vanlig extrakörning",
          desc: "Extra körningar och flexibla uppdrag när behovet uppstår.",
        },
      ],
    },
    team: {
      title: "Personalen",
      subtitle: "Människorna bakom hjulet",
      lead:
        "Hela Bränninger Åkeri står på erfarna människor med fötterna på jorden. Nedan hittar du dem som leder vår dagliga drift.",
      roles: {
        chef: "Chef",
        hr: "Personalansvarig",
        forman: "Förman",
      },
      call: "Ring",
      mail: "Mejla",
    },
    gallery: {
      title: "Galleri",
      subtitle: "Bilar, vagnpark och vardag",
      lead:
        "Ett urval av vårt åkeri, vagnpark och människorna som håller hjulen rullande. Egna bilder läggs upp löpande.",
    },
    quote: {
      title: "Begär offert",
      subtitle: "Berätta vad du behöver",
      lead:
        "Fyll i formuläret så återkommer vi med pris och tid – oftast inom 24 timmar.",
      service_label: "Typ av uppdrag",
      services: {
        offert: "Offert – Vanligt uppdrag",
        express: "Expresskörning",
        lots: "Lots / Eskort",
        extra: "Vanlig extrakörning",
      },
      fields: {
        name: "Namn",
        company: "Företag",
        email: "E-post",
        phone: "Telefon",
        pickup: "Upphämtning",
        delivery: "Leverans",
        date: "Önskat datum",
        cargo: "Gods / Beskrivning",
        message: "Meddelande",
      },
      success_title: "Tack för din förfrågan!",
      success_msg:
        "Vi har tagit emot din förfrågan och återkommer så snart vi kan.",
      new_quote: "Skicka ny förfrågan",
      error: "Något gick fel. Försök igen om en stund.",
    },
    contact: {
      title: "Kontakt",
      address: "Bunkalundsvägen 2, 253 68 Helsingborg",
      org_label: "Org.nr",
      org_no: "556712-0208",
      hours: "Beredskap dygnet runt",
    },
    story: {
      eyebrow: "Vår historia",
      title: "Bakom hjulen",
      lead:
        "Generationer av åkare, milslånga rutter och uppdrag som inte väntar. Här är vägen vi tagit.",
      chapter: "Kapitel",
    },
    testimonials: {
      eyebrow: "Vad våra kunder säger",
      title: "Ord från vägen",
      lead:
        "Förtroende byggs uppdrag för uppdrag. Här är några röster från dem vi kör för.",
    },
    admin: {
      title: "Admin – Förfrågningar",
      key_label: "Logga in",
      key_placeholder: "Ange admin-nyckel",
      unlock: "Lås upp",
      username_label: "Användarnamn",
      username_placeholder: "t.ex. mattias",
      password_label: "Lösenord",
      password_placeholder: "Ditt lösenord",
      login_btn: "Logga in",
      logout: "Logga ut",
      logged_in_as: "Inloggad som",
      change_password: "Byt lösenord",
      change_password_current: "Nuvarande lösenord",
      change_password_new: "Nytt lösenord (minst 6 tecken)",
      change_password_confirm: "Bekräfta nytt lösenord",
      change_password_mismatch: "De nya lösenorden matchar inte",
      change_password_success: "Lösenordet är ändrat!",
      change_password_save: "Byt lösenord",
      empty: "Inga förfrågningar än.",
      columns: {
        date: "Datum",
        name: "Namn",
        contact: "Kontakt",
        service: "Tjänst",
        details: "Detaljer",
        status: "Status",
        actions: "Åtgärd",
      },
      statuses: {
        new: "Ny",
        contacted: "Kontaktad",
        done: "Klar",
        archived: "Arkiverad",
      },
      delete: "Radera",
      bad_key: "Fel nyckel",
      tabs: {
        quotes: "Förfrågningar",
        team: "Personal",
        gallery: "Galleri",
        story: "Vår historia",
        testimonials: "Kundcitat",
        calendar: "Almanacka",
      },
      team: {
        title: "Hantera personal",
        add: "Lägg till medarbetare",
        upload_image: "Ladda upp bild",
        save: "Spara",
        cancel: "Avbryt",
        confirm_delete: "Radera medarbetare?",
        empty: "Ingen personal tillagd än.",
        fields: {
          role_key: "Roll",
          name: "Namn",
          phone: "Telefon",
          email: "E-post",
          sort_order: "Ordning",
        },
      },
      gallery: {
        title: "Hantera galleri",
        upload: "Ladda upp bild",
        uploading: "Laddar upp...",
        label: "Bildtext",
        confirm_delete: "Radera bild?",
        empty: "Inga bilder än. Ladda upp för att komma igång.",
      },
      story: {
        title: "Hantera \"Vår historia\"",
        lead:
          "Berätta er resa med fria text- och bildblock. Visas på startsidan i den ordning du anger.",
        add: "Lägg till block",
        empty: "Inga historieblock än. Lägg till det första.",
        confirm_delete: "Radera blocket?",
        fields: {
          title: "Rubrik",
          body: "Text",
          sort_order: "Ordning",
        },
        upload_image: "Ladda upp bild",
        remove_image: "Ta bort bild",
        save: "Spara",
        cancel: "Avbryt",
      },
      testimonials: {
        title: "Hantera kundcitat",
        lead: "Lägg in kundcitat som visas på startsidan.",
        add: "Lägg till citat",
        empty: "Inga citat än. Lägg till det första.",
        confirm_delete: "Radera citatet?",
        fields: {
          quote: "Citat",
          author_name: "Namn",
          author_role: "Roll / Företag",
          sort_order: "Ordning",
        },
        upload_image: "Ladda upp bild (valfritt)",
        remove_image: "Ta bort bild",
        save: "Spara",
        cancel: "Avbryt",
      },
      calendar: {
        title: "Gemensam almanacka",
        lead:
          "Håll koll på besiktningar, reparationer, sjukfrånvaro och semester. Bara admin ser detta.",
        add: "Lägg till händelse",
        edit: "Redigera",
        empty_day: "Inga händelser den här dagen",
        empty_all: "Inga händelser inlagda än",
        confirm_delete: "Radera händelsen?",
        today: "Idag",
        prev: "Föregående",
        next: "Nästa",
        fields: {
          title: "Rubrik",
          event_type: "Typ",
          start_date: "Startdatum",
          end_date: "Slutdatum (valfritt)",
          assignee: "Vem / Vad",
          assignee_placeholder: "T.ex. Michael, eller ABC 123",
          notes: "Anteckningar",
        },
        types: {
          besiktning: "Besiktning",
          skada: "Skada / Reparation",
          sjukdom: "Sjukdom",
          semester: "Semester",
          annat: "Annat",
        },
        save: "Spara",
        cancel: "Avbryt",
        weekdays_short: ["MÅN", "TIS", "ONS", "TOR", "FRE", "LÖR", "SÖN"],
        months: [
          "Januari", "Februari", "Mars", "April", "Maj", "Juni",
          "Juli", "Augusti", "September", "Oktober", "November", "December",
        ],
      },
    },
    footer: {
      tagline: "Vi rullar när andra stannar.",
      rights: "Alla rättigheter förbehållna.",
    },
  },

  en: {
    nav: {
      home: "Home",
      team: "Team",
      gallery: "Gallery",
      quote: "Quote",
      admin: "Admin",
    },
    common: {
      cta_quote: "Request a quote",
      learn_more: "Learn more",
      back_home: "Back to home",
      loading: "Loading...",
      submit: "Send request",
      submitting: "Sending...",
      optional: "optional",
      required: "required",
    },
    hero: {
      eyebrow: "Haulage & Logistics · SINCE 2006",
      title_l1: "Bränninger",
      title_l2: "Haulage & Logistics",
      lead:
        "Robust transport, escort and express runs – nationwide. We roll around the clock with reliable people and a strong fleet.",
      cta_primary: "Request a quote",
      cta_secondary: "Meet the team",
      stats: [
        { value: "20+", label: "Years of experience" },
        { value: "24/7", label: "On call" },
        { value: "100%", label: "Reliable deliveries" },
      ],
    },
    services: {
      title: "Services",
      subtitle: "What we drive",
      items: [
        {
          key: "offert",
          title: "Quotes",
          desc: "Get a clear, fair price on transport and logistics assignments.",
        },
        {
          key: "express",
          title: "Express runs",
          desc: "When time is critical. Fast and secure delivery to the receiver.",
        },
        {
          key: "lots",
          title: "Escort / Pilot",
          desc: "Escort service for special and oversized transports.",
        },
        {
          key: "extra",
          title: "Extra runs",
          desc: "Flexible extra haulage when the unexpected happens.",
        },
      ],
    },
    team: {
      title: "Our team",
      subtitle: "The people behind the wheel",
      lead:
        "Bränninger Åkeri stands on experienced people with their feet on the ground. Below you'll find the people leading our day to day.",
      roles: {
        chef: "Director",
        hr: "Head of HR",
        forman: "Foreman",
      },
      call: "Call",
      mail: "Email",
    },
    gallery: {
      title: "Gallery",
      subtitle: "Trucks, fleet and everyday life",
      lead:
        "A selection of our haulage company, fleet and the people that keep the wheels turning. New images are added regularly.",
    },
    quote: {
      title: "Request a quote",
      subtitle: "Tell us what you need",
      lead:
        "Fill out the form and we'll get back to you with price and timing – usually within 24 hours.",
      service_label: "Type of job",
      services: {
        offert: "Quote – Standard job",
        express: "Express run",
        lots: "Escort / Pilot",
        extra: "Extra haulage",
      },
      fields: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        pickup: "Pickup",
        delivery: "Delivery",
        date: "Preferred date",
        cargo: "Cargo / Description",
        message: "Message",
      },
      success_title: "Thanks for your request!",
      success_msg:
        "We've received your request and will get back to you shortly.",
      new_quote: "Send a new request",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      title: "Contact",
      address: "Bunkalundsvägen 2, 253 68 Helsingborg",
      org_label: "Reg. no",
      org_no: "556712-0208",
      hours: "On call 24/7",
    },
    story: {
      eyebrow: "Our story",
      title: "Behind the wheel",
      lead:
        "Generations of haulers, miles of road, and assignments that won't wait. This is the road we've travelled.",
      chapter: "Chapter",
    },
    testimonials: {
      eyebrow: "What our clients say",
      title: "Voices from the road",
      lead:
        "Trust is built one assignment at a time. Here are voices from those we drive for.",
    },
    admin: {
      title: "Admin – Requests",
      key_label: "Sign in",
      key_placeholder: "Enter admin key",
      unlock: "Unlock",
      username_label: "Username",
      username_placeholder: "e.g. mattias",
      password_label: "Password",
      password_placeholder: "Your password",
      login_btn: "Sign in",
      logout: "Sign out",
      logged_in_as: "Signed in as",
      change_password: "Change password",
      change_password_current: "Current password",
      change_password_new: "New password (min 6 chars)",
      change_password_confirm: "Confirm new password",
      change_password_mismatch: "New passwords do not match",
      change_password_success: "Password updated!",
      change_password_save: "Update password",
      empty: "No requests yet.",
      columns: {
        date: "Date",
        name: "Name",
        contact: "Contact",
        service: "Service",
        details: "Details",
        status: "Status",
        actions: "Action",
      },
      statuses: {
        new: "New",
        contacted: "Contacted",
        done: "Done",
        archived: "Archived",
      },
      delete: "Delete",
      bad_key: "Wrong key",
      tabs: {
        quotes: "Requests",
        team: "Team",
        gallery: "Gallery",
        story: "Our story",
        testimonials: "Testimonials",
        calendar: "Calendar",
      },
      team: {
        title: "Manage team",
        add: "Add member",
        upload_image: "Upload image",
        save: "Save",
        cancel: "Cancel",
        confirm_delete: "Delete member?",
        empty: "No team members yet.",
        fields: {
          role_key: "Role",
          name: "Name",
          phone: "Phone",
          email: "Email",
          sort_order: "Order",
        },
      },
      gallery: {
        title: "Manage gallery",
        upload: "Upload image",
        uploading: "Uploading...",
        label: "Caption",
        confirm_delete: "Delete image?",
        empty: "No images yet. Upload to get started.",
      },
      story: {
        title: "Manage \"Our story\"",
        lead:
          "Tell your story with free-form text + image blocks. Displayed on the homepage in the order you set.",
        add: "Add block",
        empty: "No story blocks yet. Add the first one.",
        confirm_delete: "Delete block?",
        fields: {
          title: "Title",
          body: "Body",
          sort_order: "Order",
        },
        upload_image: "Upload image",
        remove_image: "Remove image",
        save: "Save",
        cancel: "Cancel",
      },
      testimonials: {
        title: "Manage testimonials",
        lead: "Add client testimonials shown on the homepage.",
        add: "Add testimonial",
        empty: "No testimonials yet. Add the first one.",
        confirm_delete: "Delete testimonial?",
        fields: {
          quote: "Quote",
          author_name: "Name",
          author_role: "Role / Company",
          sort_order: "Order",
        },
        upload_image: "Upload image (optional)",
        remove_image: "Remove image",
        save: "Save",
        cancel: "Cancel",
      },
      calendar: {
        title: "Shared calendar",
        lead:
          "Track inspections, repairs, sick leave and vacations. Only visible to admin.",
        add: "Add event",
        edit: "Edit",
        empty_day: "No events on this day",
        empty_all: "No events yet",
        confirm_delete: "Delete event?",
        today: "Today",
        prev: "Previous",
        next: "Next",
        fields: {
          title: "Title",
          event_type: "Type",
          start_date: "Start date",
          end_date: "End date (optional)",
          assignee: "Who / What",
          assignee_placeholder: "e.g. Michael, or ABC 123",
          notes: "Notes",
        },
        types: {
          besiktning: "Inspection",
          skada: "Damage / Repair",
          sjukdom: "Sick leave",
          semester: "Vacation",
          annat: "Other",
        },
        save: "Save",
        cancel: "Cancel",
        weekdays_short: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
        months: [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December",
        ],
      },
    },
    footer: {
      tagline: "We roll when others stop.",
      rights: "All rights reserved.",
    },
  },
};
